import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, Typography, Spin, Input, InputNumber, Button, Tabs, notification } from 'antd';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';
import './BookingTransactionModal.css';

const { Text } = Typography;
const { TabPane } = Tabs;

@inject(
    'BookingTransactionStore'
)
@observer
class BookingTransactionModalPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false
        }
    }

    componentDidMount() {
    }

    // ON CHANGE

    nameEnglishOnChange = (e) => {
        this.props.BookingTransactionStore.setNameEnglish(e.target.value);
    }

    nameChineseOnChange = (e) => {
        this.props.BookingTransactionStore.setNameChinese(e.target.value);
    }

    nameChineseTraditionalOnChange = (e) => {
        this.props.BookingTransactionStore.setNameChineseTraditional(e.target.value);
    }

    nameThaiOnChange = (e) => {
        this.props.BookingTransactionStore.setNameThai(e.target.value);
    }

    nameJapaneseOnChange = (e) => {
        this.props.BookingTransactionStore.setNameJapanese(e.target.value);
    }

    descriptionEnglishOnChange = (e) => {
        this.props.BookingTransactionStore.setDescriptionEnglish(e.target.value);
    }

    descriptionChineseOnChange = (e) => {
        this.props.BookingTransactionStore.setDescriptionChinese(e.target.value);
    }

    descriptionChineseTraditionalOnChange = (e) => {
        this.props.BookingTransactionStore.setDescriptionChineseTraditional(e.target.value);
    }

    descriptionThaiOnChange = (e) => {
        this.props.BookingTransactionStore.setDescriptionThai(e.target.value);
    }

    descriptionJapaneseOnChange = (e) => {
        this.props.BookingTransactionStore.setDescriptionJapanese(e.target.value);
    }

    maxHourPerDayOnChange = (value) => {
        this.props.BookingTransactionStore.setMaxHourPerDay(value);
    }

    sortOrderOnChange = (value) => {
        this.props.BookingTransactionStore.setSortOrder(value);
    }

    // ON CLICK

    createOrUpdateBookingTransactionDetailOnClick = () => {
        this.props.BookingTransactionStore.createOrUpdateBookingTransactionDetail();
    }

    initUpdateBookingTransactionDetailOnClick = (bookingTransactionDetailId) => {
        this.props.BookingTransactionStore.initUpdateBookingTransactionDetail(bookingTransactionDetailId);
    }

    cancelBookingTransactionDetailOnClick = () => {
        this.props.BookingTransactionStore.cancelBookingTransactionDetail();
    }

    deleteBookingTransactionDetailOnClick = (bookingTransactionDetailId) => {
        this.props.BookingTransactionStore.deleteBookingTransactionDetail(bookingTransactionDetailId);
    }

    createOrUpdateBookingTransactionOnClick = () => {
        const { t } = this.props;
        const { id } = this.props.BookingTransactionStore;
        if (id === 0) {
            this.props.BookingTransactionStore.createBookingTransaction().then(response => {
                if (response.isSuccess) {
                    notification['success']({
                        message: t('Success'),
                        description: t('Booking Transaction has been successfully created.'),
                        duration: 3
                    });
                } else {
                    notification['error']({
                        message: t('Error'),
                        description: `${response.error}`,
                        duration: 3
                    });
                }
            });
        } else {
            this.props.BookingTransactionStore.updateBookingTransaction().then(response => {
                if (response.isSuccess) {
                    notification['success']({
                        message: t('Success'),
                        description: t('Booking Transaction has been successfully updated.'),
                        duration: 3
                    });
                } else {
                    notification['error']({
                        message: t('Error'),
                        description: `${response.error}`,
                        duration: 3
                    });
                }
            });
        }
    }

    // ON TAB CLICK

    tabNameOnTabClick = (key) => {
        this.props.BookingTransactionStore.setTabNameActiveKey(key);
    }

    tabDescriptionOnTabClick = (key) => {
        this.props.BookingTransactionStore.setTabDescriptionActiveKey(key);
    }

    render() {
        const { t } = this.props;
        const {
            tabNameActiveKey,
            tabDescriptionActiveKey,
            nameEnglish,
            // nameChinese,
            // nameChineseTraditional,
            nameThai,
            // nameJapanese,
            descriptionEnglish,
            // descriptionChinese,
            // descriptionChineseTraditional,
            descriptionThai,
            // descriptionJapanese,
            maxHourPerDay,
            sortOrder,
            itemTextButton,
            bookingTransactionModalLoading
        } = this.props.BookingTransactionStore;

        let addOrUpdateItemDisable = false;
        if (nameEnglish === '') {
            addOrUpdateItemDisable = true;
        }

        return (
            <Spin spinning={bookingTransactionModalLoading}>
                <Row className='bookingtransactionmodal-row-container'>
                    <Col span={24} className='bookingtransactionmodal-col'>
                        <Row>
                            <Col span={8} className='bookingtransactionmodal-col-label-tabs'>
                                <Text className='bookingtransactionmodal-text-label'>{t('Name')}<Text className='bookingtransactionmodal-text-label-mandatory'>*</Text></Text>
                            </Col>
                            <Col span={16} className='bookingtransactionmodal-col-input'>
                                <Tabs activeKey={tabNameActiveKey} onTabClick={this.tabNameOnTabClick}>
                                    <TabPane tab='English *' key='1'>
                                        <Input className='bookingtransactionmodal-input' value={nameEnglish} onChange={this.nameEnglishOnChange} />
                                    </TabPane>
                                    {/* <TabPane tab='简体中文' key='2'>
                                        <Input className='bookingtransactionmodal-input' value={nameChinese} onChange={this.nameChineseOnChange} />
                                    </TabPane>
                                    <TabPane tab='繁體中文' key='3'>
                                        <Input className='bookingtransactionmodal-input' value={nameChineseTraditional} onChange={this.nameChineseTraditionalOnChange} />
                                    </TabPane> */}
                                    <TabPane tab='ไทย' key='4'>
                                        <Input className='bookingtransactionmodal-input' value={nameThai} onChange={this.nameThaiOnChange} />
                                    </TabPane>
                                    {/* <TabPane tab='日本' key='5'>
                                        <Input className='bookingtransactionmodal-input' value={nameJapanese} onChange={this.nameJapaneseOnChange} />
                                    </TabPane> */}
                                </Tabs>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24} className='bookingtransactionmodal-col'>
                        <Row>
                            <Col span={8} className='bookingtransactionmodal-col-label-tabs'>
                                <Text className='bookingtransactionmodal-text-label'>{t('Description')}<Text className='bookingtransactionmodal-text-label-mandatory'>*</Text></Text>
                            </Col>
                            <Col span={16} className='bookingtransactionmodal-col-input'>
                                <Tabs activeKey={tabDescriptionActiveKey} onTabClick={this.tabDescriptionOnTabClick}>
                                    <TabPane tab='English *' key='1'>
                                        <Input className='bookingtransactionmodal-input' value={descriptionEnglish} onChange={this.descriptionEnglishOnChange} />
                                    </TabPane>
                                    {/* <TabPane tab='简体中文' key='2'>
                                        <Input className='bookingtransactionmodal-input' value={descriptionChinese} onChange={this.descriptionChineseOnChange} />
                                    </TabPane>
                                    <TabPane tab='繁體中文' key='3'>
                                        <Input className='bookingtransactionmodal-input' value={descriptionChineseTraditional} onChange={this.descriptionChineseTraditionalOnChange} />
                                    </TabPane> */}
                                    <TabPane tab='ไทย' key='4'>
                                        <Input className='bookingtransactionmodal-input' value={descriptionThai} onChange={this.descriptionThaiOnChange} />
                                    </TabPane>
                                    {/* <TabPane tab='日本' key='5'>
                                        <Input className='bookingtransactionmodal-input' value={descriptionJapanese} onChange={this.descriptionJapaneseOnChange} />
                                    </TabPane> */}
                                </Tabs>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24} className='bookingtransactionmodal-col'>
                        <Row>
                            <Col span={8} className='bookingtransactionmodal-col-label'>
                                <Text className='bookingtransactionmodal-text-label'>{t('Max Hour Per Day')}<Text className='bookingtransactionmodal-text-label-mandatory'>*</Text></Text>
                            </Col>
                            <Col span={16} className='bookingtransactionmodal-col-input'>
                                <InputNumber
                                    className='fnbadditionalitemmodal-inputnumber-short'
                                    min={0}
                                    value={maxHourPerDay}
                                    onChange={this.maxHourPerDayOnChange}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24} className='bookingtransactionmodal-col'>
                        <Row>
                            <Col span={8} className='bookingtransactionmodal-col-label'>
                                <Text className='bookingtransactionmodal-text-label'>{t('Sort Order')}<Text className='bookingtransactionmodal-text-label-mandatory'>*</Text></Text>
                            </Col>
                            <Col span={16} className='bookingtransactionmodal-col-input'>
                                <InputNumber
                                    className='fnbadditionalitemmodal-inputnumber-short'
                                    min={0}
                                    value={sortOrder}
                                    onChange={this.sortOrderOnChange}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24} className='bookingtransactionmodal-col-button'>
                        <Button disabled={addOrUpdateItemDisable} type='primary' className='bookingtransactionmodal-button' onClick={this.createOrUpdateBookingTransactionOnClick}>{t(itemTextButton)}</Button>
                    </Col>
                </Row>
            </Spin >
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(BookingTransactionModalPage);
